import { httpAxios } from "../utils/httpAxios";


export const contactusService = async(data)=>{
    const result= await httpAxios.post('user/contact/us',data).then((res)=>{
        return res.data
        }).catch((err)=>{
            return err.response.data;
        });  
        return result;
};